function URLFilteringCtrl($scope, $controller, $location, $timeout, $state, $filter, IconsService, GeneralUtilsService) {
    $scope.$root.dividedInner = true;

    $controller('SecurityCtrl', { $scope: $scope, $location: $location, $timeout: $timeout, $state: $state, GeneralUtilsService: GeneralUtilsService });

    $scope.triggerConfig = { label: 'Track', path: 'track', template: "<div id='trigger_{{tableConfig.type + $parent.$index}}' class='inline-block' ng-click='tableConfig.editTrigger(item,tableConfig.type + $parent.$index)'><svg class='icon track icon-track' ng-class='{on: item.trigger}'><use xlink:href='/public/images/icons/main.svg#icon-track'></use></svg></div>", noSort: true };
    $scope.showTitleSearch = false;

    $scope.freeText = null;
    $scope.tldFreeText = null;

    $scope.timeConstraints = { type: 'always', timeDef: { isA: 'Time', days: [], times: [], reoccurring: true } };
    $scope.urls = { type: 'always', timeDef: { isA: 'Time', days: [], times: [], reoccurring: true } };

    var icons = IconsService.getIcons("policy");

    $scope.configs = { site: { config: 'sitesConfig', type: 'entity' },
        urlCategories: { config: 'urlFilteringCustomConfig', type: 'entity' },
        category: { config: 'urlCategoriesConfig', type: 'entity' },
        url: { config: 'urlConfig', type: 'url' },
        tld: { config: 'tldConfig', type: 'tld' },
        accesslogin: { config: 'accessloginsConfig', type: 'entity' },
        group: { config: 'groupsConfig', type: 'entity' },
        subnet: { config: 'subnetsConfig', type: 'entity' },
        hostsubnet: { config: 'subnetsConfig', type: 'entity' },
        interfaceiprange: { config: 'ipRangesConfig', type: 'entity' },
        ip: { config: 'ipsConfig', type: 'string' },
        port: { config: 'portsConfig', type: 'string' },
        appstring: { config: 'appsConfig', type: 'list' },
        appcategory: { config: 'categoriesConfig', type: 'entity' },
        app: { config: 'appsConfig', type: 'entity' },
        service: { config: 'servicesConfig', type: 'entity' },
        os: { config: 'osConfig', type: 'list' },
        directoryserviceuser: { config: 'dsUserConfig', type: 'entity' },
        "systemgroup": {"config":"groupsConfig", "type":"entity"},
        networkinterface: { config: 'ipRangesConfig', type: 'entity' },
    };

    $scope.origRules = {};
    $scope.origCustomRules = {};

    $scope.ruleDef = { confirm: 'URL filtering', restrictionType: 'urlFiltering' };

    $scope.actionsConfig = {
        selectedAction: null,
    };

    // check if the URL contain specific category to filter according to
    $scope.chosenCategory = $state.params.categoryName;
    $scope.chosenCustomCategory = $state.params.customCategoryName;
    // remove filter according to specific category (load page without category)
    $scope.removeURLFilters = function () {
        $state.go('app.urlFiltering', {
            categoryName: null,
            customCategoryName: null,
        });
    };

    store.fetch({
        path: 'getURLFilteringRules',
        queryParams: { accountId: $state.params.accountId, type: 'account' },
        success: function (data) {
            $scope.account = data;
            $scope.account.enabled = data.urlFilteringEnabled;
            $scope.mailingLists = [];
            data.mailingDefinition.mails.forEach(function (list) {
                $scope.mailingLists.push(list.name);
            });
        },
    });

    store.fetch({
        method: 'POST',
        path: '/users',
        queryParams: {
            accountId: $state.params.accountId,
        },
        success: function (data) {
            $scope.admins = data.items;
        },
    });


    $scope.$root.hasChanges = function (id) {
        return $scope.urlFilteringConfig.hasChanges() || $scope.urlFilteringCustomConfig.hasChanges() || ($scope.account && $scope.account.enabled !== $scope.account.urlFilteringEnabled);
    };

    $scope.$root.hasCustomChanges = function (id) {
        if (!$scope.account) return false;
        var rulesChanged;
        if (id) {
            rulesChanged = $('#' + id + ' .warning:visible').length > 0;
        } else {
            rulesChanged = $('.warning:visible').length > 0;
        }
        return rulesChanged;
    };

    $scope.urlFilteringConfig = {
        allowPropagation: true,
        dataURL: function () {
            return '/urlFiltering?accountId=' + $state.params.accountId;
        },
        searchVal: $scope.chosenCategory ? $scope.chosenCategory : null, // Search for the chosen category (or get all categories)
        noSearch: true,
        showTable: false,
        titleSearch: $scope.chosenCategory ? true : 'Categories', // If we filter by specific category, do not show the search field
        fields: [
            { label: 'Category', path: 'name', template: '<span><a ui-sref="app.monitorURLs({s: item.name})">{{item.name | capitalize}}</a></span>' },
            { label: 'Action', path: 'action', template: "<div class='action-wrapper' ng-attr-title='{{tableConfig.actionData[item.action].name}}' title='{{tableConfig.actionData[item.action].name}}'><svg id='action_{{item.category}}' title='{{tableConfig.actionData[item.action].name}}.Click to change' class='url-action-button {{tableConfig.actionData[item.action].class}} icon icon-{{tableConfig.actionData[item.action].icon}}' ng-click='tableConfig.changeAction(item)'><use xlink:href='' ng-href='/public/images/icons/main.svg#icon-url-{{tableConfig.actionData[item.action].icon}}'></use></svg></div>" },
            { label: 'System Default', path: 'isDefault', template: "<div class='action-wrapper' ng-attr-title='{{tableConfig.actionData[item.defaultAction].name}}' title='{{tableConfig.actionData[item.defaultAction].name}}'><svg id='action_{{item.defaultAction}}' title='System default action for {{item.name}} is {{tableConfig.actionData[item.defaultAction].name}}' class='url-action-button {{tableConfig.actionData[item.defaultAction].class}} icon icon-{{tableConfig.actionData[item.defaultAction].icon}}'><use xlink:href='' ng-href='/public/images/icons/main.svg#icon-url-{{tableConfig.actionData[item.defaultAction].icon}}'></use></svg></div>" },
            $scope.triggerConfig,
        ],
        type: 'URLFilteringRule',
        selectedItems: [],
        hideCheckboxes: true,
        /* customButtons : [
            {'name':'save','text':'Save','func' :
                function() {
                    $scope.save();
                }
            }
        ],*/
        ruleActions: ['ALLOW', 'BLOCK', 'MONITOR', 'PROMPT'],
        actionData: {
            ALLOW: { name: 'Allow', icon: 'allow', class: 'action-allow' },
            BLOCK: { name: 'Block', icon: 'block', class: 'action-block' },
            MONITOR: { name: 'Monitor', icon: 'monitor', class: 'action-monitor' },
            PROMPT: { name: 'Prompt', icon: 'prompt', class: 'action-alert' },
        },
        changeAction: function (item) {
            $scope.$root.$emit('$openPopup', 'actions', 'action_' + item.category);
            $scope.actionsConfig.selectedAction = item.action;
            $scope.actionsConfig.rule = item;
        },
        processData: function (items, data) {
            $scope.origRules = angular.copy(items);
        },
        editTrigger: function (item, id) {
            $scope.editTrigger(item, id);
        },
        hasChanges: function () {
            return !angular.equals($scope.urlFilteringConfig.items, $scope.origRules);
//            return $scope.$root.hasChanges();
        },
        pageSize: 20,
        dataFilter: {
            field: 'action',
            filterOptions: [{ id: 'ALL', name: 'All' }, { id: 'ALLOW', name: 'Allow' }, { id: 'BLOCK', name: 'Block' }, { id: 'MONITOR', name: 'Monitor' }, { id: 'PROMPT', name: 'Prompt' }],
            selectedOption: 'ALL',
        },
    };

    $scope.urlCategoriesConfig = {
        dataURL: function () {
            return '/urlPlainUrlCategories';
        },
        showTable: false,
        actions: [],
        pageSize: 5,
        titleSearch: true,
        fixedLayout: true,
        fields: [{ label: 'Name', template: '<span>{{item.name | capitalize}}</span>', path: 'name' }],
        type: 'UrlCategory',
        selectedItems: [],
        processData: function (items) {
            items.forEach(function (item) {
                item.id = item.name;
            });
        },
    };

    $scope.dsUserConfig = {
        titleSearch: true,
        accountId: $state.params.accountId,
        dataURL: function () {
            return '/getAllDsUsers?accountId=' + $state.params.accountId;
        },
        fields: [{ label: 'Name', path: 'Login Name', template: '<span>{{item.loginName}}</span>' },
            { label: 'Subnet', path: 'Full Name', template: '<span>{{item.fullName}}</span>' },
        ],
        processData: function (items) {
//            fillSelectedItems($scope.tableConfig.items);
//            updateConfigSelectedItems($scope.hostConfig,items);
        },
        type: 'DsUser',
        actions: [],
        selectedItems: [],
        pageSize: 5,

    };

    $scope.urlFilteringCustomConfig = {
        id: 'customUrlFiltering',
        actionData: {
            ALLOW: { name: 'Allow', icon: 'allow', class: 'action-allow' },
            BLOCK: { name: 'Block', icon: 'block', class: 'action-block' },
            MONITOR: { name: 'Monitor', icon: 'monitor', class: 'action-monitor' },
            PROMPT: { name: 'Prompt', icon: 'prompt', class: 'action-alert' },
        },
        ruleAction: 'ALLOW',
        icons: icons,
        dataURL: function () {
            return '/urlFilteringCustomRules?accountId=' + $state.params.accountId;
        },
        searchVal: $scope.chosenCustomCategory ? $scope.chosenCustomCategory : null, // Search for the chosen category (or get all categories)
        noSearch: true,
        showTable: false,
        titleSearch: $scope.chosenCustomCategory ? $scope.chosenCustomCategory : 'Custom Categories', // If we filter by specific category, do not show the search field
        typeField: { label: 'Action', path: 'action', template: "<div class='action-wrapper'><svg id='c_action_{{item.name | removeSpecialChars}}' title='{{tableConfig.actionData[item.action].name}}.Click to change' class='url-action-button {{tableConfig.actionData[item.action].class}} icon icon-{{tableConfig.actionData[item.action].icon}}' ng-click='tableConfig.changeAction(item)'><use xlink:href='' ng-href='/public/images/icons/main.svg#icon-url-{{tableConfig.actionData[item.action].icon}}'></use></svg></div>" },
        fields: [
            { label: 'Name', path: 'name', template: '<span><input type="text" class="form-control ng-pristine ng-valid ng-scope ng-not-empty ng-touched" ng-model="item.name"</input></span>' },
            { class: 'entry-list', label: 'Source', path: 'source', template: "<span><entry-list items='item.source' root='item' field='source' id='source_{{tableConfig.ruleAction + $parent.$index}}' add-items='tableConfig.select(item,field,id)' mouseenterevent='tableConfig.mouseenter(item, pos)' mouseleaveevent='tableConfig.mouseleave(item)' icons='tableConfig.icons'></entry-list></span>", noSort: true, searchField: 'name' },
            { label: 'Action', path: 'action', template: "<div class='action-wrapper'><svg id='c_action_{{item.name | removeSpecialChars}}' title='{{tableConfig.actionData[item.action].name}}.Click to change' class='url-action-button {{tableConfig.actionData[item.action].class}} icon icon-{{tableConfig.actionData[item.action].icon}}' ng-click='tableConfig.changeAction(item)'><use xlink:href='' ng-href='/public/images/icons/main.svg#icon-url-{{tableConfig.actionData[item.action].icon}}'></use></svg></div>" },
            $scope.triggerConfig,
            { class: 'constraint', label: 'Limit to', path: 'constraint', template: "<span><constraint id='tableConfig.ruleAction' item='item' config='tableConfig' index='$parent.$index'/></span>", noSort: true, noSearch: true },
            { label: 'URLs', path: 'isDefault', template: '<span>{{item.urlsRaw}}</span>', noSort: true },
            { label: 'Last Modified', path: 'lastModified', template: '', noSort: false, noSearch: true },
        ],
        editTable: true,
        getStatus: function (rule) {
            if (!$scope.ignoreChanges) {
                var status = 'saved';
                if (rule.id < 0) {
                    status = 'new';
                }
                var origRule = $scope.origCustomRules[rule.id];
                if (origRule && !angular.equals(rule, origRule)) {
                    status = 'changed';
                }
                rule.status = status;
                return status;
            }

            return rule.status;
        },
        type: 'URLFilteringCustomRule',
        selectUrl: function (item, field, id) {
            $scope.showApp = 'category';
            $scope.$root.openPopup('urls');
            var configs = { urlcategory: 'urlsCategoryConfig', url: 'urlConfig' };
            $scope.currentAction = this.ruleAction;
            this.doSelect(item, field, configs);
        },
        select: function (item, field, id) {
            $scope.showItem = 'group';
            $scope.$root.openPopup('addItem');
            $scope.currentAction = this.ruleAction;
            this.doSelect(item, field);
        },
        doSelect: function (currItem, field) {
            angular.forEach($scope.configs, function (config) {
                if ($scope[config.config]) {
                    if (config.type === 'entity' || config.type === 'list') {
                        $scope[config.config].selectedItems = [];
                    } else if (config.type === 'string') {
                        $scope[config.config].selectedItems = '';
                    }
                }
            });

            var items = currItem[field];
            var _urls = [];
            var _tlds = [];
            items.forEach(function (item) {
                if (item.name != 'Any' && item.type) {
                    var config = $scope.configs[item.type.toLowerCase()];
                    if (config.type === 'entity') {
                        if (!item.id) {
                            item.id = item.name;
                        }
                        $scope[config.config].selectedItems.push(item);
                    } else if (config.type === 'string') {
                        if ($scope[config.config].selectedItems.length > 0) {
                            $scope[config.config].selectedItems += ',';
                        }
                        $scope[config.config].selectedItems += item.name;
                    } else if (config.type === 'list') {
                        $scope[config.config].selectedItems.push({ id: item.name });
                    } else if (config.type === 'url') {
                        _urls.push(item.name);
                    } else if (config.type === 'tld') {
                        _tlds.push(item.name);
                    }
                }
//                else if (item !== Object(item)) {
//                    _urls.push(item.name)
//                }
            });
            $scope.freeText = _urls.length > 0 ? _urls.join() : null;
            $scope.tldFreeText = _tlds.length > 0 ? _tlds.join() : null;
            $scope.scopeSelection = { item: currItem, type: field };
        },
        editConstraints: function (item, id) {
            if (!item.constraint) {
                item.constraint = { predicates: [], op: 'OP_EQ' };
            }
            $scope.timeConstraints = { type: 'always', timeDef: { isA: 'Time', days: [], times: [], reoccurring: true } };
            if (item.constraint.predicates.time) {
                item.constraint.predicates.time.values.forEach(function (value) {
                    if (typeof value === 'string') {
                        $scope.timeConstraints.type = value;
                    } else {
                        $scope.timeConstraints.type = 'custom';
                        $scope.timeConstraints.timeDef = value;
                    }
                });
            } else {
                $scope.timeConstraints.type = 'always';
            }

            $scope.bwConstraints = { download: null };
            if (item.constraint.predicates.limit_bw && item.constraint.predicates.limit_bw.values[0]) {
                $scope.bwConstraints.download = parseInt(item.constraint.predicates.limit_bw.values[0]);
            } else {
                $scope.bwConstraints.download = null;
            }

            $scope.scopeSelection = { item: item };
            $scope.showConstraint = 'time';
            $scope.$root.openPopup('constraintEditor');
        },
        selectedItems: [],
        hideCheckboxes: true,
        /* customButtons : [
            {'name':'save','text':'Save','func' :
                function() {
                    $scope.saveCustom();
                }
            }
        ],*/
        specialActions: [
            {
                icon: 'add',
                tooltip: 'Add',
                func: function (selectedItems, config) {
                    var randomId = Math.floor((Math.random() * 100000000000000) + 1);
                    if (!config.items) {
                        config.items = [];
                    }
                    config.items.unshift({ source: [],
                        urlAndCategories: [],
                        categories: [],
                        urls: [],
                        urlObjects: [],
                        id: randomId * -1,
                        ruleAction: config.ruleAction,
                        fileSize: $scope.defaultFileSize,
                        enabled: true });
                    config.items[0].action = 'ALLOW';
                },
            },
            {
                icon: 'delete',
                tooltip: 'Delete',
                func: function (selectedItems, config) {
                    $scope.removeItems(selectedItems, config);
                },
            },
        ],

        ruleActions: ['ALLOW', 'BLOCK', 'MONITOR', 'PROMPT'],

        changeAction: function (item) {
            $scope.$root.$emit('$openPopup', 'customCategoryActions', 'c_action_' + (item.name ? $filter('removeSpecialChars')(item.name) : ''));
            $scope.actionsConfig.selectedAction = item.action;
            $scope.actionsConfig.rule = item;
        },
        processData: function (items, data) {
            if (typeof this.typeProcessData === 'function') {
                this.typeProcessData(items);
            }
            items.forEach(function (item) {
                item.status = 'saved';
                if (item.any) {
                    item.urlAndCategories = [{ name: 'Any', id: -1 }];
                } else {
                    item.urlObjects = [];
                    item.urls.forEach(function (url) {
                        item.urlObjects.push({ name: url, id: url, type: 'url' });
//                        url.type = 'url';
                    });
                    item.tlds.forEach(function (tld) {
                        item.urlObjects.push({ name: tld, id: tld, type: 'tld' });
//                        url.type = 'url';
                    });
                    item.categories.forEach(function (cat) {
                        cat.id = cat.name;
                        cat.type = 'category';
                    });
                    item.urlAndCategories = angular.copy(item.urlObjects);
                    item.urlAndCategories = item.urlAndCategories.concat(item.categories);
                }
            });
            var orig = angular.copy(items);
            orig.forEach(function (rule) {
                $scope.origCustomRules[rule.id] = rule;
            });
        },
        editTrigger: function (item, id) {
            $scope.editTrigger(item, id);
        },
        hasChanges: function () {
            return $scope.$root.hasCustomChanges();
        },
        pageSize: 20,
    };

    $scope.setAction = function (popup) {
        $scope.actionsConfig.rule.action = $scope.actionsConfig.selectedAction;
        $scope.$root.$emit('$closePopup', popup);
//        $scope.actionsConfig.selectedAction = null;
    };

    $scope.save = function () {
        $scope.urlFilteringCustomConfig.items.forEach(function (item) {
            item.categories = [];
            item.urls = [];
            item.tlds = [];
            item.urlAndCategories.forEach(function (urlOrCat) {
                if (urlOrCat.id && urlOrCat.id == -1) {
                    item.any = true;
                    item.categories = [];
                    item.urls = [];
                    item.tlds = [];
                    return;
                }
                item.any = false;
                if (urlOrCat.type == 'category') {
                    item.categories.push(urlOrCat);
                } else if (urlOrCat.type == 'url') {
                    item.urls.push(urlOrCat.name);
                } else if (urlOrCat.type == 'tld') {
                    item.tlds.push(urlOrCat.name);
                }
            });
        });
        $scope.account.customUrlFiltering = $scope.urlFilteringCustomConfig.items;
        $scope.account.urlFiltering = $scope.urlFilteringConfig.items;
        $scope.account.urlFilteringEnabled = $scope.account.enabled;
        $scope.account.newSaveMethod = true;
        $scope.loading = true;
        store.save({
            path: '/edit',
            data: $scope.account,
            dataObj: 'json',
            queryParams: { accountId: $state.params.accountId, save: true, fields: "['urlFiltering', 'customUrlFiltering', 'urlFilteringEnabled']" },
            success: function (data) {
                $timeout(function() {
                    $scope.loading = false;
                }, 0);

                $scope.$root.handleServerResponse(data, '', 'URL Filtering rules saved successfully');
                if (data.status !== 'ERROR') {
                    $scope.datamodified = new Date().getTime();
                    $scope.customdatamodified = new Date().getTime();

                    if (!$scope.$root.useNewFW) {
                       $scope.$root.alert('Cato migrated the rules for the security policy to the new firewall (the URL Filtering rules are migrated to the new Internet firewall). Any changes to the previous firewall rules are not applied to the new firewall. You are ONLY configuring the previous firewall.');
                    }
                }
            },
        });
    };

    $scope.allowAny = function () {
        $scope.scopeSelection.item[$scope.scopeSelection.type] = [{ id: -1, name: 'Any' }];
        $scope.allowAnyItems = false;
    };


    $scope.addUrls = function () {
        // any item
        if ($scope.allowAnyItems) {
            $scope.allowAny();
            $scope.$root.closePopup('urls');
            return;
        }

        var curItems = [];
        var itemTypes = [{ name: 'UrlCategories', type: 'category' }];
        var config = $scope.urlCategoriesConfig;

        for (var key in itemTypes) {
            var typeDef = itemTypes[key];
            config.selectedItems.forEach(function (item) {
                item.type = typeDef.type;
            });
            curItems = curItems.concat(config.selectedItems);
        }
        var _urls = $scope.freeText ? $scope.freeText.split(',') : [];
        _urls.forEach(function (_url) {
            if (_url) {
                curItems.push({ name: _url.trim(), id: _url.trim(), type: 'url' });
            }
        });
        var _tlds = $scope.tldFreeText ? $scope.tldFreeText.split(',') : [];
        _tlds.forEach(function (_tld) {
            if (_tld) {
                curItems.push({ name: _tld.trim(), id: _tld.trim(), type: 'tld' });
            }
        });
        $scope.freeText = null;
        $scope.tldFreeText = null;
        $scope.scopeSelection.item[$scope.scopeSelection.type] = curItems;
        $scope.$root.closePopup('urls');
    };



    $scope.addConstraints = function () {
        var item = $scope.scopeSelection.item;
        item.constraint.predicates = {};

        if ($scope.timeConstraints.type == 'always') {
            delete item.constraint.predicates.time;
        } else if ($scope.timeConstraints.type == 'workingHours') {
            item.constraint.predicates.time = { field: { name: 'time' }, op: 'OP_LE', values: ['workingHours'] };
        } else { // custom
            item.constraint.predicates.time = { field: { name: 'time' }, op: 'OP_LE', values: [$scope.timeConstraints.timeDef] };
        }

        $scope.$root.closePopup('constraintEditor');
    };

    $scope.removeItems = function (selectedItems, config) {
        var len = selectedItems.length;
        if (len == 0) {
            $scope.$root.alert('Please select items to delete');
            return;
        }
        var itemsToDelete = [];
        selectedItems.forEach(function (item) {
            itemsToDelete.push(item.id);
        });
        var itemsMessage = len == 1 ? 'one rule' : len + ' rules';
        $scope.$root.confirm('Are you sure you want to remove ' + itemsMessage + '?', function () {
            store.remove({
                type: 'urlfiltercustomcategory',
                items: itemsToDelete,
                success: function (data) {
                    itemsToDelete.forEach(function (item) {
                        var pos = null;
                        for (var i = 0; i < config.items.length; i++) {
                            if (config.items[i].id == item) {
                                pos = i;
                                break;
                            }
                        }
                        if (pos != null) {
                            config.items.splice(pos, 1);
                        }
                    });
                    config.selectedItems = [];

                    $scope.$root.handleServerResponse(data, '', 'Rules removed successfully');
                },
            });
        });
    };

    $scope.addItems = function () {
        if ($scope.allowAnyItems) {
            $scope.allowAny();
            $scope.$root.closePopup('addItem');
            return;
        }
        var curItems = [];
        var itemTypes = ['groups', 'sites', 'subnets', 'accesslogins', 'ipRanges', 'dsUser'];
        for (var key in itemTypes) {
            var config = $scope[itemTypes[key] + 'Config'];
            curItems = curItems.concat(config.selectedItems);
        }
        $scope.scopeSelection.item[$scope.scopeSelection.type] = curItems;
        $scope.$root.closePopup('addItem');
    };


    $scope.sitesConfig = {
        titleSearch: true,
        dataURL: function () {
            var accountId = $scope.currentAccountId || $state.params.accountId;
            return '/sites?accountId=' + accountId;
        },
        showTable: false,
        fields: [{ label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' },
            { label: 'Address', path: 'address', template: '<span>{{item.address}}</span>' },
        ],
        type: 'Site',
        actions: [],
        selectedItems: [],
        pageSize: 5,
    };

    $scope.accessloginsConfig = {
        titleSearch: true,
        statusNames: { DISABLED: 'Disabled', ACTIVE: 'Configured', SUSPENDED: 'Suspended', NEW: 'New', PENDING_USER_CONFIGURATION: 'Invitation Sent' },
        loginNameById: {},
        dataURL: function () {
            var accountId = $scope.currentAccountId || $state.params.accountId;
            return '/logins?accountId=' + accountId;
        },
        fields: [{ label: 'Name', path: 'name', template: '<span>{{item.name}}<span>' },
            { label: 'E-mail', path: 'email' },
        ],
        type: 'AccessLogin',
        actions: [],
        selectedItems: [],
        pageSize: 5,
    };

    $scope.groupsConfig = {
        titleSearch: true,
        dataURL: function () {
            var accountId = $scope.currentAccountId || $state.params.accountId;
            return '/groups?accountId=' + accountId;
        },
        fixedLayout: true,
        showTable: false,
        fields: [{ label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' },
            { label: 'Description', path: 'description', template: '<span>{{item.description}}</span>' },
        ],
        type: 'Group',
        actions: [],
        selectedItems: [],
        pageSize: 5,
    };

    $scope.subnetsConfig = {
        titleSearch: true,
        dataURL: function () {
            var accountId = $scope.currentAccountId || $state.params.accountId;
            return '/subnets?accountId=' + accountId;
        },
        showTable: false,
        fields: [
            { label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' },
            { label: 'Site', name: 'siteName', template: '<span>{{item.siteName}}</span>' },
            { label: 'Network', path: 'interfaceName', template: "<span>{{item.interfaceName}} <span ng-if='item.range'> \\ {{item.range}}</span></span>" },
            { label: 'IP', path: 'subnet', template: '<span>{{item.translatedSubnet}}</span>' },
        ],
        type: 'Subnet',
        actions: [],
        selectedItems: [],
        pageSize: 5,
    };

    $scope.ipRangesConfig = {
        titleSearch: 'Range',
        searchField: 'display_name',
        fixedLayout: true,
        dataURL: function () {
            return '/getNetworks?isRequestFromOFE=1&accountId=' + $state.params.accountId;
        },
        showTable: false,
        fields: [
            {label: 'Name', path: 'name', template: '<span>{{item.name}}</span>'},
            { label: 'Site', path: 'siteName', template: '<span>{{item.siteName}}</span>' },
            { label: 'Interface', path: 'interfaceName', template: '<span>{{item.interfaceName}}</span>' },
            { label: 'Type', path: 'type', template: '<span>{{item.type | capitalize}}</span>' },
            { label: 'Range', path: 'subnet', template: '<span>{{item.subnet}}</span>' },
        ],
        type: 'IPRange',
        actions: [],
        selectedItems: [],
        pageSize: 5,
    };
}
